export function initialize() {
    let crsl = $('#myCarousel');
    let percent = 0;

    function progressBarCarousel(bar) {
        bar.css({width: percent + '%'});
        percent = percent + 0.5;
        if (percent > 100) {
            percent = 0;
            crsl.carousel('next');
        }
    }

    if(crsl.length > 0) {
        let bar = $('.transition-timer-carousel-progress-bar');

        crsl.carousel({
            interval: false,
            pause: 'hover'
        }).on('slid.bs.carousel', function () {
            percent = 0;
        });

        let barInterval = setInterval(function() {
            progressBarCarousel(bar);
        }, 30);

        crsl.hover(
            function () {
                clearInterval(barInterval);
            },
            function () {
                clearInterval(barInterval);
                barInterval = setInterval(function() {
                    progressBarCarousel(bar);
                }, 30);
            }
        );
    }
}

export default {
};
